import React from "react";
import { selectObjectDetailsView, type DetailsRow } from "./objectDetailsSelectors";
import { FiBox, FiSearch, FiX } from "react-icons/fi";
import styles from "./McBimItemDetailsTable.module.css";

export function ObjectDetailsPanel({
  rows,
  search,
  onSearch,
  mmi,
  onClose,
  additionalSections,
}: {
  rows: DetailsRow[];
  search: string;
  onSearch: (value: string) => void;
  mmi?: React.ReactNode;
  onClose?: () => void;
  additionalSections?: React.ReactNode;
}) {
  const { title, subtitle, tags, visible, query, count } = selectObjectDetailsView(rows, search);

  return (
    <div className={styles.panel}>
      <header className={styles.header}>
        <div className={styles.headerRow}>
          <div className={styles.eyebrow}>
            <FiBox aria-hidden="true" /> OBJEKTDETALJER
          </div>
          {onClose && <button type="button" className={styles.close} onClick={onClose}
            aria-label="Lukk objektdetaljer og fjern objektvalg" title="Lukk objektdetaljer">
            <FiX size={18} aria-hidden="true" />
          </button>}
        </div>
        <h2>{title}</h2>
        {subtitle && <p>{subtitle}</p>}
        <div className={styles.tags}>
          {tags.map((tag) => (
            <span key={tag}>{tag}</span>
          ))}
        </div>
        {mmi && <div className={styles.mmi}>{mmi}</div>}
      </header>
      <div className={styles.search}>
        <FiSearch aria-hidden="true" />
        <input
          aria-label="Søk i objektdetaljer"
          placeholder="Søk i navn, verdier og egenskaper…"
          value={search}
          onChange={(event) => onSearch(event.target.value)}
        />
        {search && (
          <button type="button" onClick={() => onSearch("")} aria-label="Tøm søk">
            ×
          </button>
        )}
      </div>
      <div className={styles.sections}>
        {additionalSections}
        {query && (
          <p className={styles.resultCount} role="status">
            {count} treff
          </p>
        )}
        {visible.map(({ name, entries, open }) => (
          <details key={`${name}-${Boolean(query)}`} className={styles.section} open={open}>
            <summary>
              {name}
              <span>{entries.length}</span>
            </summary>
            <dl>
              {entries.map((row, index) => (
                <div key={`${row.label}-${index}`} className={styles.property}>
                  <dt>{row.label}</dt>
                  <dd className={row.empty ? styles.empty : undefined}>{row.displayValue}</dd>
                </div>
              ))}
            </dl>
          </details>
        ))}
        {!visible.length && (
          <p className={styles.noResults}>
            {query ? "Ingen egenskaper samsvarer med søket." : "Ingen detaljer tilgjengelig."}
          </p>
        )}
      </div>
    </div>
  );
}
